// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.styles_container__kE0vS {
  padding: 3rem; }
  @media (max-width: 768px) {
    .styles_container__kE0vS {
      padding: 0.5rem;
      min-width: 90vw; } }
  .styles_container__kE0vS h2 {
    font-size: 1rem;
    margin: 0.5rem; }
  .styles_container__kE0vS .styles_inputContainer__iUyaN {
    width: -webkit-fill-available;
    display: flex;
    justify-content: center; }
    .styles_container__kE0vS .styles_inputContainer__iUyaN > div {
      width: -webkit-fill-available; }
      @media (max-width: 768px) {
        .styles_container__kE0vS .styles_inputContainer__iUyaN > div {
          max-width: 90%; } }
`, "",{"version":3,"sources":["webpack://./src/modules/Core/sub-modules/Translation/components/DefaultLanguageModal/styles.module.scss","webpack://./src/modules/Core/styles/mixins.scss"],"names":[],"mappings":"AACA;EACI,aAAa,EAAA;ECMf;IDPF;MAGQ,eAAe;MACf,eAAe,EAAA,EAkBtB;EAtBD;IAQQ,eAAe;IACf,cAAc,EAAA;EATtB;IAYQ,6BAA6B;IAC7B,aAAa;IACb,uBAAuB,EAAA;IAd/B;MAgBY,6BAA6B,EAAA;MCTvC;QDPF;UAkBgB,cAAc,EAAA,EAErB","sourcesContent":["@import \"src/modules/Core/styles/mixins.scss\";\n.container {\n    padding: 3rem;\n    @include mobile {\n        padding: 0.5rem;\n        min-width: 90vw;\n    }\n\n    & h2 {\n        font-size: 1rem;\n        margin: 0.5rem;\n    }\n    .inputContainer {\n        width: -webkit-fill-available;\n        display: flex;\n        justify-content: center;\n        & > div {\n            width: -webkit-fill-available;\n            @include mobile {\n                max-width: 90%;\n            }\n        }\n    }\n}\n","// @import \"src/modules/Core/styles/mixins.scss\";\n@mixin respond-to($breakpoint) {\n  @media (max-width: $breakpoint) {\n    @content;\n  }\n}\n\n@mixin mobile {\n  @media (max-width: 768px) {\n    @content;\n  }\n}\n\n@mixin multilineText($lines){\n  -webkit-line-clamp: $lines;\n  -webkit-box-orient: vertical;\n  overflow: hidden;\n  display: -webkit-box;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `styles_container__kE0vS`,
	"inputContainer": `styles_inputContainer__iUyaN`
};
export default ___CSS_LOADER_EXPORT___;
